import { fetchShops } from 'admin/actions/shops';
import Select from 'admin/components/atoms/Select';
import OrganizationSelector from 'admin/components/organisms/OrganizationSelector';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../hooks/useApp';
import { selectUserPrivateMoney } from '../../reducers/user-private-money';
import SelectedPrivateMoneyDisplay from './SelectedPrivateMoneyDisplay';

const ShopSelector = ({ onChangeShop, onChangeMoney, designatedMoney, disabled, ...rest }) => {
  const userPrivateMoney = useAppSelector(selectUserPrivateMoney);

  const [shopOps, setShopOps] = useState();
  const [selectedShopOp, setSelectedShopOp] = useState();
  const [selectedOrg, setSelectedOrg] = useState({});

  useEffect(() => {
    if (userPrivateMoney) {
      handleMoneySelect(userPrivateMoney);
    }

    if (userPrivateMoney.id && selectedOrg.code) {
      const query = `private_money_id=${userPrivateMoney.id}&organization_code=${selectedOrg.code}`;
      fetchShops(query).then((shops) => {
        const ops = shops.map((s) => ({ label: s.name, value: s }));
        setShopOps(ops);
      });
    }
  }, [selectedOrg, userPrivateMoney]);

  useEffect(() => {
    if (selectedShopOp) {
      onChangeShop(selectedShopOp.value);
    }
  }, [selectedShopOp]);

  const handleMoneySelect = (money) => {
    if (selectedOrg.code) {
      setSelectedOrg({});
    }
    setSelectedShopOp(null);
    if (onChangeMoney) {
      onChangeMoney(money);
    }
  };

  const handleOrganizationSelect = (org) => {
    setSelectedOrg(org);
    setSelectedShopOp(null);
    onChangeShop(null);
  };

  const handleShopSelect = (op) => {
    setSelectedShopOp(op);
  };

  return (
    <div {...rest}>
      <SelectedPrivateMoneyDisplay />
      <OrganizationSelector
        privateMoney={userPrivateMoney}
        onChangeOrganization={handleOrganizationSelect}
        disabled={disabled}
      />
      <Select
        options={shopOps}
        onChange={handleShopSelect}
        placeholder="「店舗」を選択"
        value={selectedShopOp}
        isDisabled={disabled}
      />
    </div>
  );
};

export default styled(ShopSelector)`
  display: inline-flex;
  & > * {
    flex-basis: 33%;
    min-width: 250px;
    width: ${(props) => (props.itemWidth ? props.itemWidth : 'auto')}
    margin-right: 5px;
  }
  & > *:first-child {
    margin-left: 0;
  }
  & > *:last-child {
    margin-right: 5px;
  }
`;
